var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contribute-tab"},_vm._l((_vm.tabList),function(item,index){return _c('div',{staticClass:"tab-item",class:{ select: index == _vm.current },on:{"click":(_) => {
        !index ? _vm.$emit('changeTab', index) : _vm.$router.push('contact-online');
      }}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }